import {
  CreateSellerRequestBuilder,
  GetSellersBuilder,
  GetSellersCountBuilder,
  UpdateSellerStatusRequestBuilder,
} from '../sellers/sellers';

import Client from '../client';
import {flattenObject} from '../helpers';

const token = localStorage.getItem('token') || '';

class SellersRepository {
  getSellers = async (actions: any) => {
    const makeRequest = new GetSellersBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetSellersCountBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeActiveCardCountRequest = new GetSellersCountBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          sort: 'id,desc',
          'status.in': ['ACTIVE'],
        })
      )
      .build();
    const makeInactiveCardCountRequest = new GetSellersCountBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          sort: 'id,desc',
          'status.in': ['INACTIVE'],
        })
      )
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    const count = await client.execute(makeCountRequest);
    const activeCardCount = await client.execute(makeActiveCardCountRequest);
    const inactiveCardCount = await client.execute(
      makeInactiveCardCountRequest
    );
    return {response, count, activeCardCount, inactiveCardCount};
  };
  updateSellerStatus = async (actions: any) => {
    const {id, body, pagination} = actions.payload;
    const makeUpdateSellerStatusRequest = new UpdateSellerStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateSellerStatusRequest);
    return pagination;
  };
  createSeller = async (actions: any) => {
    const {body, pagination, callback} = actions.payload;
    const makeAddSellerRequest = new CreateSellerRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeAddSellerRequest);
    return {pagination, callback};
  };
}

export default new SellersRepository();
